export const meta = {
  title: '隐私政策 | Firefly Wedding',
  description:
    'Firefly Wedding 粉丝站如何处理访客数据、Cookie、统计分析与可选账号。',
  updated_at: '2026-10-14',
};

## 关于本政策

Firefly Wedding（fireflywedding.org）是一个非官方粉丝站，整理《ホタルの嫁入り（萤火之嫁）》漫画与动画的公开资讯，并链接至官方来源。本政策说明你访问本站时我们会处理哪些信息。如有疑问请联系 [support@fireflywedding.org](mailto:support@fireflywedding.org)。

## 我们收集的信息

- **基础访问数据**：与所有网站一样，托管服务商会处理你的 IP 地址、浏览器类型和所访问的页面，用于提供服务和防范滥用。
- **偏好设置**：你选择的语言和明暗主题会保存在 Cookie 或浏览器本地存储中。
- **统计分析**：我们可能使用 Google Analytics、Plausible 或 Microsoft Clarity 等工具了解哪些页面更有用，这些工具会收到汇总的使用数据并可能设置各自的 Cookie。
- **可选账号**：如果你注册账号，我们会保存你的邮箱、昵称和登录信息。浏览所有公开页面都无需注册。

## 外部链接

观看与阅读链接会将你带到 Crunchyroll、电视台、流媒体平台和出版社等第三方服务，离开本站后适用其各自的隐私政策。

## 共享与保留

我们不会出售个人数据，仅在运营所需时与服务商（托管、统计、邮件）共享，或依法提供。账号数据会保留至你要求删除为止。

## 你的选择

你可以在浏览器中屏蔽或清除 Cookie，也可以发送邮件至 [support@fireflywedding.org](mailto:support@fireflywedding.org) 查询或删除账号数据。

## 政策更新

本政策可能随网站发展而更新，页首日期为最新版本。
